import React from "react";

// Assets
import "~/assets/sass/pages/invest/IrModal/history.scss";

const HistoryView = ({ irHistory }) => {
	return (
		<>
			{/*주요연혁 view*/}
			<div className="history-view">
				<div className="yearly-history">
					<h3 className="year">{irHistory[0]?.date.substring(0, 4)}</h3>

					<ol>
						{irHistory.map((d) => (
							<li className="form-data-group" key={d.idx}>
								<span className="history-date">{d.date.substring(0, 7)}</span>
								<ul className="history-content">
									<li>{d.content}</li>
								</ul>
							</li>
						))}
					</ol>
				</div>
			</div>
		</>
	);
};

export default HistoryView;
